$(function() {
  $('.js-ask-display-btn').on('click', function() {
    $('.js-ask-modal').modal('show')
  })
})
